// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-close{
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.edit-category-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  z-index: 1000;
}

.edit-category-modal {
  width: min(560px, 92vw);
}

.edit-category-overlay .add-category-container {
  margin: 0;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Masters/category/EditCategory/EditCategory.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,WAAW;AACb","sourcesContent":[".button-close{\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.edit-category-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(6px);\n  z-index: 1000;\n}\n\n.edit-category-modal {\n  width: min(560px, 92vw);\n}\n\n.edit-category-overlay .add-category-container {\n  margin: 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
